import React from "react";
import styled from "styled-components";

const Title = styled.h2`
  font-weight: 400;
  text-transform: uppercase;
  text-align: center;
`;

const Text = styled.p`
  text-align: center;
`;

const ImageContainer = styled.div`
  width: 404px;
  margin: 3rem auto;

  img {
    width: 404px;
    height: auto;
    display: block;
  }
`;

export default () => {
  // tslint:disable-next-line:max-line-length
  const text =
    "The following is a schematic of the procedure used to determine the countries that are included in the Atlas Complexity Ranking";
  return (
    <>
      <Title>See What Countries Are Included</Title>
      <Text>{text}</Text>
      <ImageContainer>
        <img
          src={require("./ranking-diagram.png")}
          alt="Countries inclusion funnel diagram"
        />
      </ImageContainer>
    </>
  );
};
